module.exports = __webpack_public_path__ + "static/media/confetti_6.977291ca.svg";